import React, { Component, useState, Fragment, useEffect } from "react";
import { injectIntl } from "react-intl";
import CustomSelectInput from "Components/CustomSelectInput";
import Select from "react-select";
import { ThemeColors } from "Util/ThemeColors";
import API from "../../api/index";
import { birthYears, birthDays, dayAfterMonthChange, validBirthDay, validBirthYear } from '../../util/customerBirthday';
var classNames = require("classnames");

import Switch from "rc-switch";
import "rc-switch/assets/index.css";

import { Alert, Row, Card, CardBody, CardTitle, Form, FormGroup, Button, CustomInput, Label, Input, Collapse, Modal, ModalBody, ModalHeader, ModalFooter, timeoutsShape } from "reactstrap";

import NumericInput from "react-numeric-input";
import NumberFormat from "react-number-format";

import { Colxx } from "Components/CustomBootstrap";
import { NotificationManager } from "Components/ReactNotifications";

import IranStates from "Data/iran-states.json";
import IranCities from "Data/iran-cities.json";
import TehranZones from "Data/tehran-zones.json";
// const ProductCategories = [...new Set(ProductsData.map(item => item.category))];
const colors = ThemeColors();
class TakeOrder extends Component {
	constructor(props) {
		super(props);

		this.state = {
			couponCode: "",
			couponID: -1,
			lookingUpCoupon: false,
			coupon: [],
			ModalMap: false,
			DeliveryInPerson: false,
			lastPrepareDataSelectedAddressId: -1,
			savingCustomer: false,
			familirtyMethod: "",
			FamiliarityMethods: ["مشتری قبلی هستم", "از سرچ گوگل", "اینستاگرام", "مغازه جمال زاده", "تبلیغات اینترنتی", "پیامک تخفیف"],
			shamsiMonths: ["فروردین", "اردیبهشت", "خرداد", "تیر", "مرداد", "شهریور", "مهر", "آبان", "آذر", "دی", "بهمن", "اسفند"],
			birthDaySelectData: {
				months: [],
				years: birthYears(),
			},
			SelectedAddressId: -1,
			genderMap: [],
			paymentType: "other",
			savingNewAddress: false,
			newAddress: {
				State: {
					label: "استان",
					value: -1,
				},
				City: {
					label: "شهر",
					value: -1,
				},
				Zone: {
					label: "محدوده",
					value: -1,
				},
				Gender: "none",
				Name: "",
				SurName: "",
				Mobile: "",
				Tel: "",
				PostCode: "",
				Address: "",
			},
			toggleNewAddress: false,
			order: {},
			addresses: [],
			isLoading: true,
		};

		this.state.birthDaySelectData.months.push({
			value: -1,
			label: "ماه",
		});
		for (var i = 0; i < this.state.shamsiMonths.length; i++) {
			this.state.birthDaySelectData.months.push({
				value: i + 1,
				label: this.state.shamsiMonths[i],
			});
		}

		this.state.genderMap["FEMALE"] = "خانم";
		this.state.genderMap["MALE"] = "آقای";
		this.getFactorTotalPrice = this.getFactorTotalPrice.bind(this);
		this.getFactorTotalCounts = this.getFactorTotalCounts.bind(this);
		this.loadData = this.loadData.bind(this);
		this.prepareData = this.prepareData.bind(this);
		this.handleChangeState = this.handleChangeState.bind(this);
		this.handleChangeCity = this.handleChangeCity.bind(this);
		this.handleChangeZone = this.handleChangeZone.bind(this);
		this.addressAdd = this.addressAdd.bind(this);
		this.addressDelete = this.addressDelete.bind(this);
		this.customerSet = this.customerSet.bind(this);
		this.orderSet = this.orderSet.bind(this);
		this.addressValidate = this.addressValidate.bind(this);
		this.customerValidate = this.customerValidate.bind(this);
		this.orderValidate = this.orderValidate.bind(this);
		this.ModalMapToggle = this.ModalMapToggle.bind(this);
		this.couponLookup = this.couponLookup.bind(this);
		this.formatNumber = this.formatNumber.bind(this);
		this.couponCalculateDiscount = this.couponCalculateDiscount.bind(this);
		this.calculatePayable = this.calculatePayable.bind(this);
		this.couponApply = this.couponApply.bind(this);
	}
	componentDidMount() {
		this.loadData();
	}
	calculatePayable() {
		return this.state.order.TotalPriceBeforeDiscount - this.couponCalculateDiscount().amount - this.state.order.DiscountAmount + this.state.order.AdditionalFee;
	}
	formatNumber(number) {
		return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	}
	couponCalculateDiscount() {
		if (this.state.couponID != -1) {
			const factorTotal = this.state.order.TotalPriceBeforeDiscount;
			const couponAmount = this.state.coupon.amount;
			const couponMinSpend = this.state.coupon.minSpend;

			if (this.state.coupon.type == "FIXED") {
				if (couponMinSpend > factorTotal) {
					return {
						amount: 0,
						info: "حداقل سفارش:  " + this.formatNumber(couponMinSpend) + " تومان",
						type: "COUPON",
						infoColor: "error",
					};
				} else {
					return {
						amount: couponAmount,
						info: "کوپن " + this.formatNumber(couponAmount) + "  تومان",
						type: "COUPON",
						infoColor: "success",
					};
				}
			} else if (this.state.coupon.type == "PERCENT") {
				if (couponMinSpend > factorTotal) {
					return {
						amount: 0,
						info: "حداقل سفارش: " + this.formatNumber(couponMinSpend) + " تومان",
						type: "COUPON",
						infoColor: "error",
					};
				} else {
					return {
						amount: Math.floor((couponAmount * factorTotal) / 100),
						info: "کوپن " + couponAmount + " %",
						type: "COUPON",
						infoColor: "success",
					};
				}
			}
		} else {
			return {
				amount: 0,
				info: "",
				type: "INPUT",
			};
		}
	}
	couponApply() {
		this.setState({ lookingUpCoupon: true });
		API.CUST.Coupon.Apply({ couponCode: this.state.coupon.code, orderId: this.state.order.OrderId })
			.then((data) => {
				if (data.RESULT === "SUCCESS") {
					alert("کوپن اعمال شد");
					window.location.reload();
				} else {
					this.setState({
						lookingUpCoupon: false,
					});
				}

				if (data.ERRORS !== undefined) {
					for (var i = 0; i < data.ERRORS.length; i++) {
						setTimeout(
							function (err) {
								NotificationManager.error(err, "اعمال کوپن", 8000, null, null, "filled");
							},
							(i + 1) * 700,
							data.ERRORS[i]
						);
					}
				}
			})
			.catch((error) => {
				this.setState({
					lookingUpCoupon: false,
				});
				NotificationManager.error("مشکل در اعمال کوپن", "اعمال کوپن", 8000, null, null, "filled");
			});
	}
	couponLookup() {
		this.setState({ lookingUpCoupon: true });
		API.CUST.Coupon.LookUp({ couponCode: this.state.couponCode, orderId: this.state.order.OrderId })
			.then((data) => {
				if (data.COUPON !== undefined) {
					this.setState({ coupon: data.COUPON, lookingUpCoupon: false, couponID: data.COUPON.couponID });
				} else {
					this.setState({
						coupon: {},
						lookingUpCoupon: false,
						couponID: -1,
					});
				}

				if (data.ERRORS !== undefined) {
					for (var i = 0; i < data.ERRORS.length; i++) {
						setTimeout(
							function (err) {
								NotificationManager.error(err, "بررسی کوپن", 8000, null, null, "filled");
							},
							(i + 1) * 700,
							data.ERRORS[i]
						);
					}
				}
			})
			.catch((error) => {
				this.setState({
					coupon: {},
					lookingUpCoupon: false,
					couponID: -1,
				});
				NotificationManager.error("مشکل در بررسی کوپن", "بررسی کوپن", 8000, null, null, "filled");
			});
	}
	ModalMapToggle() {
		this.setState({
			ModalMap: !this.state.ModalMap,
		});
	}
	handleFocus = (event) => event.target.select();
	handleChangeState = (state) => {
		var _newAddress = this.state.newAddress;
		_newAddress.State = state;
		this.setState({ newAddress: _newAddress });
	};

	handleChangeCity = (city) => {
		var _newAddress = this.state.newAddress;
		_newAddress.City = city;
		this.setState({ newAddress: _newAddress });
	};

	handleChangeZone = (zone) => {
		var _newAddress = this.state.newAddress;
		_newAddress.Zone = zone;
		this.setState({ newAddress: _newAddress });
	};

	loadData() {
		this.setState({ isLoading: true, loadError: false });
		API.CUST.Order.Get({ AccessCode: this.props.match.params.AccessCode })
			.then((data) => {
				if (!data || !data.order || !data.order.Customer) {
					throw new Error("Order unavailable");
				}
				this.prepareData(data);
			})
			.catch(() => {
				this.setState({ isLoading: false, loadError: true, order: {}, addresses: [] });
			});
	}
	prepareData(data) {
		this.setState({ lastPrepareDataSelectedAddressId: data.order.SelectedAddressId });
		if (data.order.Customer.Gender == null) {
			data.order.Customer.Gender = "none";
		}

		data.order.Customer.BirthDay.Day = {
			label: data.order.Customer.BirthDay.Day == -1 ? "روز" : data.order.Customer.BirthDay.Day,
			value: data.order.Customer.BirthDay.Day,
		};

		data.order.Customer.BirthDay.Month = {
			label: data.order.Customer.BirthDay.Month == -1 ? "ماه" : this.state.shamsiMonths[data.order.Customer.BirthDay.Month - 1],
			value: data.order.Customer.BirthDay.Month,
		};

		data.order.Customer.BirthDay.Year = {
			label: data.order.Customer.BirthDay.Year == -1 ? "سال" : data.order.Customer.BirthDay.Year,
			value: data.order.Customer.BirthDay.Year,
		};

		this.setState({ DeliveryInPerson: data.order.DeliveryInPerson == "1" ? true : false });
		// if (data.order.CustPaymentSelection != null) {
		// this.setState({paymentType: data.order.CustPaymentSelection});
		// }
		if (data.order.Customer.BasicInfoLock === true) {
			this.setState({
				newAddress: {
					State: {
						label: "استان",
						value: -1,
					},
					City: {
						label: "شهر",
						value: -1,
					},
					Zone: {
						label: "محدوده",
						value: -1,
					},
					Gender: data.order.Customer.Gender,
					Name: data.order.Customer.Name,
					SurName: data.order.Customer.SurName,
					Mobile: data.order.Customer.Mobile,
					Tel: "",
					PostCode: "",
					Address: "",
				},
			});
		}

		data.order.Customer.Name = data.order.Customer.Name == null ? "" : data.order.Customer.Name;
		data.order.Customer.SurName = data.order.Customer.SurName == null ? "" : data.order.Customer.SurName;
		data.order.NoteCustomer = data.order.NoteCustomer == null ? "" : data.order.NoteCustomer;
		if (data.addresses.length == 0) {
			data.order.SelectedAddressId = -1;
		}
		data.order.SelectedAddressId = parseInt(data.order.SelectedAddressId);
		(data.order.SelectedAddressId = data.order.SelectedAddressId > -1 ? data.order.SelectedAddressId : data.addresses.length == 0 ? -1 : data.addresses[0].AddressId),
			this.setState({
				order: data.order,
				addresses: data.addresses,
				isLoading: false,
				FamiliarityMethods: data.familiarityMethods,
				toggleNewAddress: data.addresses.length == 0,
			});
	}
	cleanMobile(mobile) {
		mobile = mobile.split(" ").join("");
		mobile = mobile.replace(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d)).replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));

		// console.log(mobile,mobile.indexOf("0098"))
		if (mobile.indexOf("0098") === 0) {
			mobile = mobile.replace("0098", "0");
		}
		if (mobile.indexOf("098") === 0) {
			mobile = mobile.replace("098", "0");
		}
		if (mobile.indexOf("+98") === 0) {
			mobile = mobile.replace("+98", "0");
		}
		if (mobile.indexOf("98") === 0) {
			mobile = mobile.replace("98", "0");
		}
		if (mobile.indexOf("9") === 0 && mobile.length == 10) {
			mobile = "0" + mobile;
		}
		return mobile;
	}
	handleBirthMonthChange(month) {
		this.setState(({ order }) => ({
			order: {
				...order,
				Customer: {
					...order.Customer,
					BirthDay: {
						...order.Customer.BirthDay,
						Month: month,
						Day: dayAfterMonthChange(order.Customer.BirthDay.Day, month.value),
					},
				},
			},
		}));
	}
	customerValidate(section = "ALL") {
		if (section == "ALL" || section == "GENDER") {
			if (this.state.order.Customer.Gender != "MALE" && this.state.order.Customer.Gender != "FEMALE") {
				return false;
			}
		}

		if (section == "ALL" || section == "NAME") {
			if (this.state.order.Customer.Name.length < 3 || !/^[\u0600-\u06FF\s]+$/.test(this.state.order.Customer.Name)) {
				return false;
			}
		}

		if (section == "ALL" || section == "SURNAME") {
			if (this.state.order.Customer.SurName.length < 3 || !/^[\u0600-\u06FF\s]+$/.test(this.state.order.Customer.SurName)) {
				return false;
			}
		}

		if (section == "ALL" || section == "BIRTHDAY-DAY") {
			if (!validBirthDay(this.state.order.Customer.BirthDay.Day.value, this.state.order.Customer.BirthDay.Month.value)) {
				return false;
			}
		}

		if (section == "ALL" || section == "BIRTHDAY-MONTH") {
			if (this.state.order.Customer.BirthDay.Month.value < 1 || this.state.order.Customer.BirthDay.Month.value > 12) {
				return false;
			}
		}
		if (section == "ALL" || section == "BIRTHDAY-YEAR") {
			if (!validBirthYear(this.state.order.Customer.BirthDay.Year.value)) {
				return false;
			}
		}

		if (section == "ALL" || section == "FAMILIARITY") {
			if (this.state.FamiliarityMethods.indexOf(this.state.order.Customer.FamiliarityMethod) === -1) {
				return false;
			}
		}

		return true;
	}
	orderValidate(section) {
		if (section == "ALL" || section == "ADDRESS") {
			if (this.state.order.SelectedAddressId == -1) {
				return false;
			}
		}

		return true;
	}
	addressValidate(section) {
		if (section == "ALL" || section == "STATE") {
			if (this.state.newAddress.State.value == -1) {
				return false;
			}
		}

		if (section == "ALL" || section == "CITY") {
			if (this.state.newAddress.City.value == -1) {
				return false;
			}
		}

		if (section == "ALL" || section == "ZONE") {
			if (this.state.newAddress.City.value == 301 && this.state.newAddress.State.value == 8 && this.state.newAddress.Zone.value == -1) {
				return false;
			}
		}

		if (section == "ALL" || section == "ADDRESS") {
			if (this.state.newAddress.Address.length < 5) {
				return false;
			}
		}

		if (section == "ALL" || section == "GENDER") {
			if (this.state.newAddress.Gender != "MALE" && this.state.newAddress.Gender != "FEMALE") {
				return false;
			}
		}

		if (section == "ALL" || section == "NAME") {
			if (this.state.newAddress.Name.length < 3 || !/^[\u0600-\u06FF\s]+$/.test(this.state.newAddress.Name)) {
				return false;
			}
		}

		if (section == "ALL" || section == "SURNAME") {
			if (this.state.newAddress.SurName.length < 3 || !/^[\u0600-\u06FF\s]+$/.test(this.state.newAddress.SurName)) {
				return false;
			}
		}

		if (section == "ALL" || section == "MOBILE") {
			if (this.state.newAddress.Mobile.length != "09121281022".length || this.state.newAddress.Mobile.match(/^(0)+(9|$)\d{9}$/g) == null) {
				return false;
			}
		}

		return true;
	}
	addressAdd() {
		if (this.addressValidate()) {
			this.setState({ savingNewAddress: true });
			API.CUST.Address.Add({
				AccessCode: this.props.match.params.AccessCode,
				Address: this.state.newAddress,
			})
				.then((data) => {
					this.setState({ savingNewAddress: false });
					this.prepareData(data);

					this.setState({
						newAddress: {
							State: {
								label: "استان",
								value: -1,
							},
							City: {
								label: "شهر",
								value: -1,
							},
							Zone: {
								label: "محدوده",
								value: -1,
							},
							Gender: this.state.order.Customer.Gender,
							Name: this.state.order.Customer.Name,
							SurName: this.state.order.Customer.SurName,
							Mobile: this.state.order.Customer.Mobile,
							Tel: "",
							PostCode: "",
							Address: "",
						},
					});

					// data.SelectedAddressId = parseInt(data.SelectedAddressId);
					// var tmpObj = this.state.order;
					// tmpObj.SelectedAddressId = data.SelectedAddressId;
					// this.setState({
					//     addresses: data.Addresses,
					//     order: tmpObj,
					//     savingNewAddress: false,
					//     toggleNewAddress: false
					// });
				})

				.catch((error) => {});
		}
	}
	addressDelete(AddressId) {
		if (this.state.order.Position == "PAYMENT") {
			if (confirm("آیا از حذف این آدرس اطمینان دارید؟")) {
				if (this.state.order.SelectedAddressId == AddressId) {
					this.setState({ SelectedAddressId: -1 });
				}
				this.setState({ deletingAddress: true });
				API.CUST.Address.Deactive({
					AccessCode: this.props.match.params.AccessCode,
					AddressId: AddressId,
				})
					.then((data) => {
						this.setState({ deletingAddress: false });
						this.prepareData(data);
					})
					.catch((error) => {});
			}
		}
	}
	customerSet() {
		if (this.customerValidate("ALL")) {
			this.setState({ savingCustomer: true });
			API.CUST.Customer.Set({
				AccessCode: this.props.match.params.AccessCode,
				Customer: this.state.order.Customer,
			})
				.then((data) => {
					this.prepareData(data);
					this.setState({ savingCustomer: false });
				})
				.catch(() => {
					this.setState({ savingCustomer: false });
					NotificationManager.error("ذخیره اطلاعات انجام نشد. لطفاً تاریخ تولد و اتصال اینترنت را بررسی کنید.", "اطلاعات مشتری", 8000);
				});
		}
	}
	orderSet() {
		if (this.orderValidate()) {
			this.setState({ savingOrder: true });
			API.CUST.Order.Set({
				AccessCode: this.props.match.params.AccessCode,
				OrderInfo: {
					SelectedAddressId: this.state.order.SelectedAddressId,
					PaymentMethod: this.state.paymentType,
					NoteCustomer: this.state.order.NoteCustomer,
					DeliveryInPerson: this.state.DeliveryInPerson,
				},
			})
				.then((data) => {
					if (data.GateWayUrl != null && data.GateWayUrl != undefined) {
						NotificationManager.success("درحال انتقال به درگاه بانکی.", "سفارش ثبت شد.", 8000, null, null, "filled");
						window.location = data.GateWayUrl;
					} else {
						this.prepareData(data);
						this.setState({ savingOrder: false });
						NotificationManager.warning("در انتظار پرداخت و ارسال رسید.", "سفارش ثبت شد.", 8000, null, null, "filled");
					}
				})
				.catch((error) => {});
		}
	}
	toggleNewAddress() {
		const prevState = this.state.toggleNewAddress;
		this.setState({
			toggleNewAddress: !prevState,
		});
	}
	getFactorTotalCounts = () => {
		var total = 0;
		for (var i = 0; i < this.state.order.Products.length; i++) {
			total += this.state.order.Products[i].Count;
		}
		return total;
	};
	getFactorTotalPrice = () => {
		var total = 0;
		for (var i = 0; i < this.state.order.Products.length; i++) {
			total += this.state.order.Products[i].Count * this.state.order.Products[i].Price;
		}

		return total;
	};
	render() {
		let finalAddress;

		if (this.state.loadError) {
			return (
				<Alert color="warning" role="alert">
					دریافت سفارش امکان‌پذیر نیست. لطفاً لینک سفارش و اتصال اینترنت را بررسی کنید.
					<Button color="link" onClick={() => this.loadData()}>تلاش دوباره</Button>
				</Alert>
			);
		}

		return this.state.isLoading ? (
			<div className="loading"></div>
		) : (
			<Fragment>
				<Row className="mb-4">
					<Colxx xxs="12">
						<Form>
							<FormGroup row>
								<Colxx md={3} className={"mobile-hide"}></Colxx>
								<Colxx md={6}>
									<Card>
										<CardBody style={{ paddingBottom: "0px" }}>
											<CardTitle>
												<div className={"iconsminds-billing headingicon"} />
												سفارش شماره #{this.state.order.OrderId}
												<div style={{ float: "left", fontSize: "14px" }} className={"text-muted"}>
													<i
														className={classNames({
															"iconsminds-business-man": this.state.order.Customer.Gender == "MALE" ? true : false,
															"iconsminds-business-woman": this.state.order.Customer.Gender == "FEMALE" ? true : false,
														})}
													></i>

													{this.state.order.Customer.Mobile}
												</div>
											</CardTitle>
											<table className="table mobile-hide factor-table">
												<thead>
													<tr>
														<th colSpan={1}>ردیف</th>
														<th colSpan={1}>نام محصول</th>
														<th style={{ textAlign: "center" }}>قیمت واحد</th>
														<th style={{ textAlign: "center" }}>تعداد </th>
														<th style={{ textAlign: "center", minWidth: "120px" }}>قیمت کل</th>
													</tr>
												</thead>
												<tbody>
													{this.state.order.Products.map((row, index) => (
														<FactorTableRow key={index} data={row} index={index} />
													))}
												</tbody>
												<tfoot>
													<tr className="order-new-table-totalrow" style={{ borderTop: "3px solid lightgray" }}>
														<td colSpan="1" style={{ maxWidth: "40px", verticalAlign: "middle" }}>
															<div style={{ fontSize: "24px" }} className={"glyph-icon iconsminds-cash-register-2"} />
														</td>
														<td className="order-new-table-width55 font-weight-semibold " style={{ verticalAlign: "middle" }}>
															جمع کل
														</td>
														<td className="order-new-table-width15 font-weight-semibold " style={{ verticalAlign: "middle" }}>
															-
														</td>
														<td className="order-new-table-width15  " style={{ verticalAlign: "middle" }}>
															<NumberFormat value={this.getFactorTotalCounts()} displayType={"text"} suffix={" عدد"} thousandSeparator={true} renderText={(value, price) => <span className="dataItemCount">{value}</span>} />
														</td>
														<td className="order-new-table-width15  " style={{ verticalAlign: "middle" }}>
															<NumberFormat value={this.getFactorTotalPrice()} displayType={"text"} suffix={" تومان"} thousandSeparator={true} renderText={(value, price) => <span className="dataItemCount">{value}</span>} />
														</td>
													</tr>
												</tfoot>
												{this.state.order.CouponUse !== false ? (
													this.state.order.CouponUse.map((row) => (
														<tfoot>
															<tr className="order-new-table-totalrow" style={{ background: "#f0f0f0" }}>
																<td style={{ width: "40px", verticalAlign: "middle" }} colSpan="1">
																	<div style={{ fontSize: "24px" }} className={"glyph-icon iconsminds-project"} />
																</td>
																<td className="order-new-table-width55 font-weight-semibold " style={{ verticalAlign: "middle" }}>
																	کوپن تخفیف
																	<span style={{ color: "lightgray", display: "block", fontSize: "12px", marginTop: "5px" }}>
																		{row.coupon.amount} {row.coupon.type == "PERCENT" ? "%" : "تومان"}
																	</span>
																</td>
																<td colSpan="3" className="order-new-table-width15 font-weight-semibold " style={{ verticalAlign: "middle" }}>
																	<div className={"coupon "} style={{ color: "#556270" }}>
																		<span>{row.coupon.code}</span>
																	</div>
																</td>
															</tr>
														</tfoot>
													))
												) : (
													<tfoot>
														<tr className="order-new-table-totalrow" style={{ background: colors.themeColor2 }}>
															<td style={{ width: "40px", verticalAlign: "middle", color: "black" }} colSpan="1">
																<div style={{ fontSize: "24px" }} className={"glyph-icon iconsminds-project"} />
															</td>
															<td className="order-new-table-width55 font-weight-semibold " style={{ color: "black", verticalAlign: "middle" }}>
																کوپن تخفیف
																<span style={{ color: this.state.couponID == -1 ? "black" : "green", fontWeight: "normal", display: "block", fontSize: "12px", marginTop: "5px" }}>
																	{this.state.couponID == -1 ? "اگر کوپن تخفیف دارید در کادر وارد کنید سپس دکمه بررسی را بزنید." : "نمایش موقت تخفیف کوپن. در صورت تایید روی 'اعمال کوپن' کلیک کنید."}
																</span>
															</td>
															<td colSpan="3" className="order-new-table-width15 font-weight-semibold " style={{ verticalAlign: "middle" }}>
																{this.state.lookingUpCoupon ? (
																	<div className="loading loading-inline" style={{ display: "inline-block", marginRight: "10px", marginTop: "10px" }}></div>
																) : (
																	<Button
																		className={"default mb-1"}
																		outline
																		color={"info"}
																		disabled={this.state.lookingUpCoupon}
																		style={{ background: "white", float: "left", display: "inline", border: "unset", width: "40px", marginRight: "5px", borderRadius: 4, padding: "11px" }}
																		onClick={() => {
																			this.couponLookup();
																		}}
																	>
																		<div className={"simple-icon-magnifier tableheadingicon"} />
																	</Button>
																)}

																<Input
																	autoComplete="off"
																	type="text"
																	name="couponCode"
																	id="couponCode"
																	placeholder="COUPON-CODE"
																	style={{ textAlign: "left", display: "inline-block", borderColor: colors.themeColor1, width: "auto", float: "left" }}
																	value={this.state.couponCode}
																	disabled={this.state.lookingUpCoupon}
																	onChange={(e) => {
																		this.setState({ couponCode: e.target.value });
																	}}
																/>
															</td>
														</tr>
														{this.state.couponID != -1 ? (
															<tr className="order-new-table-totalrow" style={{ background: colors.themeColor2 }}>
																<td style={{ width: "40px", verticalAlign: "middle", color: "black" }} colSpan="1">
																	<div style={{ fontSize: "24px" }} className={"glyph-icon iconsminds-dollar"} />
																</td>
																<td colSpan="1" className="order-new-table-width55 font-weight-semibold " style={{ color: "black", verticalAlign: "middle" }}>
																	تخفیف کوپن
																</td>

																<td
																	colSpan="2"
																	className="order-new-table-width15 font-weight-semibold "
																	style={{ verticalAlign: "middle", textAlign: "left", color: this.couponCalculateDiscount().infoColor == "error" ? "red" : "green" }}
																>
																	{this.couponCalculateDiscount().info}
																</td>

																<td className="order-new-table-width55 font-weight-semibold " style={{ textAlign: "center", verticalAlign: "middle" }}>
																	<NumberFormat
																		value={this.couponCalculateDiscount().amount}
																		displayType={"text"}
																		suffix={" تومان"}
																		thousandSeparator={true}
																		renderText={(value, price) => <span className="dataItemCount">{value}</span>}
																	/>
																</td>
															</tr>
														) : (
															<tr />
														)}

														{this.state.couponID != -1 ? (
															<tr style={{ background: colors.themeColor2 }}>
																<td colSpan={5}>
																	<Button
																		onClick={() => {
																			this.couponApply();
																		}}
																		color="light"
																		disabled={this.state.lookingUpCoupon}
																		className={"default mb-2"}
																		style={{ width: "100%", color: "white", background: this.state.order.SelectedAddressId == -1 ? "#fa9800" : "#4fcdc4", display: "inline-block", fontSize: "18px" }}
																	>
																		اعمال کوپن و ثبت نهایی &nbsp;
																		<i className={"simple-icon-arrow-left-circle"} style={{ fontSize: "20px" }}></i>
																	</Button>
																</td>
															</tr>
														) : (
															<></>
														)}
													</tfoot>
												)}
												<tfoot>
													{this.state.order.DiscountAmount > 0 ? (
														<tr className="order-new-table-totalrow">
															<td style={{ width: "40px", verticalAlign: "middle" }} colSpan="1">
																<div style={{ fontSize: "24px" }} className={"glyph-icon iconsminds-dollar"} />
															</td>
															<td colSpan="2" className="order-new-table-width55 font-weight-semibold " style={{ verticalAlign: "middle" }}>
																تخفیف
															</td>
															<td className="order-new-table-width15 font-weight-semibold " style={{ verticalAlign: "middle", textAlign: "left" }}>
																{this.state.order.DiscountPercent} %
															</td>
															<td className="order-new-table-width55 font-weight-semibold " style={{ textAlign: "center", verticalAlign: "middle" }}>
																<NumberFormat
																	value={this.state.order.DiscountAmount}
																	displayType={"text"}
																	suffix={" تومان"}
																	thousandSeparator={true}
																	renderText={(value, price) => <span className="dataItemCount">{value}</span>}
																/>
															</td>
														</tr>
													) : (
														<tr />
													)}

													<tr className="order-new-table-totalrow">
														<td style={{ width: "40px" }} colSpan="1">
															<div style={{ fontSize: "24px" }} className={"glyph-icon iconsminds-scooter"} />
														</td>
														<td colSpan="2" className="order-new-table-width55 font-weight-semibold ">
															هزینه حمل و جانبی
														</td>
														<td></td>
														<td className="order-new-table-width55 font-weight-semibold " style={{ textAlign: "center" }}>
															<NumberFormat
																value={this.state.order.AdditionalFee}
																displayType={"text"}
																suffix={" تومان"}
																thousandSeparator={true}
																renderText={(value, price) => <span className="dataItemCount">{value}</span>}
															/>
														</td>
													</tr>
													<tr className="order-new-table-totalrow black-total-row">
														<td style={{ width: "40px" }} colSpan="1">
															<div style={{ fontSize: "24px", color: "white", verticalAlign: "middle" }} className={"glyph-icon iconsminds-coins"} />
														</td>
														<td className="order-new-table-width55 font-weight-semibold " style={{ color: "white", verticalAlign: "middle" }}>
															قابل پرداخت
														</td>
														<td className="order-new-table-width15 font-weight-semibold " style={{ color: "black", verticalAlign: "middle" }}>
															-
														</td>
														<td className="order-new-table-width15 font-weight-semibold " style={{ color: "black", verticalAlign: "middle" }}>
															<NumberFormat value={this.getFactorTotalCounts()} displayType={"text"} suffix={" عدد"} thousandSeparator={true} renderText={(value, price) => <span className="dataItemCount">{value}</span>} />
														</td>
														{this.state.order.CouponUse !== false || this.state.couponID == -1 ? (
															<td className="order-new-table-width15 font-weight-semibold " style={{ color: "black", verticalAlign: "middle" }}>
																<NumberFormat value={this.state.order.Payable} displayType={"text"} suffix={" تومان"} thousandSeparator={true} renderText={(value, price) => <span className="dataItemCount">{value}</span>} />
															</td>
														) : (
															<td className="order-new-table-width15 font-weight-semibold  " style={{ verticalAlign: "middle" }}>
																<span className={"new-total"}>
																	<NumberFormat
																		value={this.calculatePayable()}
																		displayType={"text"}
																		suffix={" تومان"}
																		thousandSeparator={true}
																		renderText={(value, price) => <span className="dataItemCount">{value}</span>}
																	/>
																</span>

																<span className={"old-total"}>
																	<NumberFormat
																		value={this.state.order.TotalPriceBeforeDiscount + this.state.order.AdditionalFee}
																		displayType={"text"}
																		suffix={" تومان"}
																		thousandSeparator={true}
																		renderText={(value, price) => <span className="dataItemCount">{value}</span>}
																	/>
																</span>
															</td>
														)}
													</tr>

													{this.state.order.NotePublic != null && this.state.order.NotePublic.trim() != "" ? (
														<tr>
															<td colSpan="1">
																<div style={{ fontSize: "24px", color: "black" }} className={"glyph-icon simple-icon-flag"} />
															</td>
															<td colSpan="4">
																<label>توضیح عمومی برای درج در فاکتور:</label>

																<ul className={"comment-text notemarker"}>
																	{this.state.order.NotePublic.split("\n").map((content, key) => {
																		if (content.trim() == "") {
																			return;
																		}
																		return (
																			<li className={"notecontent"} key={key}>
																				{content.indexOf("|") === -1 ? (
																					content
																				) : (
																					<ul style={{ fontSize: "12px", listStyle: "none", background: "rgba(255,255,255,0.8)", padding: "10px" }}>
																						{content.split("|").map((contentItem, key2) => {
																							if (contentItem.trim() == "") {
																								return;
																							}
																							return <li key={key2}>{contentItem}</li>;
																						})}
																					</ul>
																				)}
																			</li>
																		);
																	})}
																</ul>
															</td>
														</tr>
													) : (
														<tr />
													)}
												</tfoot>
											</table>

											{/* 
                                                FOR MOBILE VIEW
                                                */}
											<table className="table mobile-show factor-table" style={{ display: "table !important" }}>
												{this.state.order.Products.map((row, index) => (
													<FactorMobileTableRow key={index} data={row} index={index} />
												))}

												<tfoot>
													<tr className="order-new-table-totalrow" style={{ borderTop: "3px solid lightgray" }}>
														<td colSpan="2" style={{ textAlign: "right" }}>
															جمع کل
														</td>
														<td colSpan="2" className="order-new-table-width15  ">
															<NumberFormat value={this.getFactorTotalCounts()} displayType={"text"} suffix={" عدد"} thousandSeparator={true} renderText={(value, price) => <span className="dataItemCount">{value}</span>} />
														</td>
														<td colSpan="2" className="order-new-table-width15  ">
															<NumberFormat value={this.getFactorTotalPrice()} displayType={"text"} suffix={" تومان"} thousandSeparator={true} renderText={(value, price) => <span className="dataItemCount">{value}</span>} />
														</td>
													</tr>
												</tfoot>
												{this.state.order.CouponUse !== false ? (
													this.state.order.CouponUse.map((row) => (
														<tfoot>
															<tr className="order-new-table-totalrow" style={{ background: "#f0f0f0" }}>
																<td colSpan="1" className="order-new-table-width55 font-weight-semibold " style={{ verticalAlign: "middle" }}>
																	کوپن تخفیف
																	<span style={{ color: "lightgray", display: "block", fontSize: "12px", marginTop: "5px" }}>
																		{row.coupon.amount} {row.coupon.type == "PERCENT" ? "%" : "تومان"}
																	</span>
																</td>

																<td colSpan="4" className="order-new-table-width15 font-weight-semibold " style={{ verticalAlign: "middle" }}>
																	<div className={"coupon "} style={{ color: "#556270" }}>
																		<span>{row.coupon.code}</span>
																	</div>
																</td>
															</tr>
														</tfoot>
													))
												) : (
													<tfoot>
														<tr className="order-new-table-totalrow" style={{ background: colors.themeColor2 }}>
															<td colSpan="6" className="order-new-table-width55 font-weight-semibold " style={{ textAlign: "right", color: "black", verticalAlign: "middle" }}>
																کوپن تخفیف
																<span style={{ color: this.state.couponID == -1 ? "black" : "green", fontWeight: "normal", display: "block", fontSize: "12px", marginTop: "5px" }}>
																	{this.state.couponID == -1 ? "اگر کوپن تخفیف دارید در کادر وارد کنید سپس دکمه بررسی را بزنید." : "نمایش موقت تخفیف کوپن. در صورت تایید روی 'اعمال کوپن' کلیک کنید."}
																</span>
															</td>
														</tr>
														<tr className="order-new-table-totalrow" style={{ background: colors.themeColor2 }}>
															<td colSpan="6" className="order-new-table-width15 font-weight-semibold " style={{ verticalAlign: "middle" }}>
																{this.state.lookingUpCoupon ? (
																	<div className="loading loading-inline" style={{ display: "inline-block", marginRight: "10px", marginTop: "10px" }}></div>
																) : (
																	<Button
																		className={"default mb-1"}
																		outline
																		color={"info"}
																		disabled={this.state.lookingUpCoupon}
																		style={{ background: "white", float: "left", display: "inline", border: "unset", width: "40px", marginRight: "5px", borderRadius: 4, padding: "11px" }}
																		onClick={() => {
																			this.couponLookup();
																		}}
																	>
																		<div className={"simple-icon-magnifier tableheadingicon"} />
																	</Button>
																)}

																<Input
																	autoComplete="off"
																	type="text"
																	name="couponCode"
																	id="couponCode"
																	placeholder="COUPON-CODE"
																	style={{ textAlign: "left", display: "inline-block", borderColor: colors.themeColor1, width: "auto", float: "left" }}
																	value={this.state.couponCode}
																	disabled={this.state.lookingUpCoupon}
																	onChange={(e) => {
																		this.setState({ couponCode: e.target.value });
																	}}
																/>
															</td>
														</tr>
														{this.state.couponID != -1 ? (
															<tr className="order-new-table-totalrow" style={{ background: colors.themeColor2 }}>
																<td colSpan="1" className="order-new-table-width55 font-weight-semibold " style={{ color: "black", verticalAlign: "middle" }}>
																	تخفیف کوپن
																</td>

																<td
																	colSpan="2"
																	className="order-new-table-width15 font-weight-semibold "
																	style={{ verticalAlign: "middle", textAlign: "left", color: this.couponCalculateDiscount().infoColor == "error" ? "red" : "green" }}
																>
																	{this.couponCalculateDiscount().info}
																</td>

																<td colSpan="2" className="order-new-table-width55 font-weight-semibold " style={{ textAlign: "center", verticalAlign: "middle" }}>
																	<NumberFormat
																		value={this.couponCalculateDiscount().amount}
																		displayType={"text"}
																		suffix={" تومان"}
																		thousandSeparator={true}
																		renderText={(value, price) => <span className="dataItemCount">{value}</span>}
																	/>
																</td>
															</tr>
														) : (
															<tr />
														)}

														{this.state.couponID != -1 ? (
															<tr style={{ background: colors.themeColor2 }}>
																<td colSpan={5}>
																	<Button
																		onClick={() => {
																			this.couponApply();
																		}}
																		color="light"
																		disabled={this.state.lookingUpCoupon}
																		className={"default mb-2"}
																		style={{ width: "100%", color: "white", background: this.state.order.SelectedAddressId == -1 ? "#fa9800" : "#4fcdc4", display: "inline-block", fontSize: "18px" }}
																	>
																		اعمال کوپن و ثبت نهایی &nbsp;
																		<i className={"simple-icon-arrow-left-circle"} style={{ fontSize: "20px" }}></i>
																	</Button>
																</td>
															</tr>
														) : (
															<></>
														)}
													</tfoot>
												)}
												<tfoot>
													{this.state.order.DiscountAmount > 0 ? (
														<tr className="order-new-table-totalrow">
															<td style={{ textAlign: "right" }}>
																<span>تخفیف</span>
															</td>

															<td colSpan="2" className="order-new-table-width15 font-weight-semibold " style={{ verticalAlign: "middle", textAlign: "center" }}>
																{this.state.order.DiscountPercent} %
															</td>
															<td colSpan="2" className="order-new-table-width55 font-weight-semibold " style={{ textAlign: "left", verticalAlign: "middle" }}>
																<NumberFormat
																	value={this.state.order.DiscountAmount}
																	displayType={"text"}
																	suffix={" تومان"}
																	thousandSeparator={true}
																	renderText={(value, price) => <span className="dataItemCount">{value}</span>}
																/>
															</td>
														</tr>
													) : (
														<tr />
													)}
													<tr className="order-new-table-totalrow">
														<td style={{ textAlign: "right" }} colSpan="3">
															<span>هزینه حمل و جانبی</span>
														</td>
														<td colSpan={2} className="order-new-table-width55 font-weight-semibold " style={{ textAlign: "left" }}>
															<NumberFormat
																value={this.state.order.AdditionalFee}
																displayType={"text"}
																suffix={" تومان"}
																thousandSeparator={true}
																renderText={(value, price) => <span className="dataItemCount">{value}</span>}
															/>
														</td>
													</tr>
													<tr className="order-new-table-totalrow mobile-total-row">
														<td style={{ textAlign: "right" }} colSpan="2">
															<span className="order-new-table-width55 font-weight-semibold " style={{ color: "black" }}>
																قابل پرداخت
															</span>
														</td>
														<td colSpan={1} className="order-new-table-width15 font-weight-semibold " style={{ color: "black" }}>
															<NumberFormat value={this.getFactorTotalCounts()} displayType={"text"} suffix={" عدد"} thousandSeparator={true} renderText={(value, price) => <span className="dataItemCount">{value}</span>} />
														</td>
														{this.state.order.CouponUse !== false || this.state.couponID == -1 ? (
															<td colSpan={3} className="order-new-table-width15 font-weight-semibold " style={{ color: "black", textAlign: "left", verticalAlign: "middle" }}>
																<NumberFormat value={this.state.order.Payable} displayType={"text"} suffix={" تومان"} thousandSeparator={true} renderText={(value, price) => <span className="dataItemCount">{value}</span>} />
															</td>
														) : (
															<td colSpan={3} className="order-new-table-width15 font-weight-semibold  " style={{ verticalAlign: "middle" }}>
																<span className={"new-total"}>
																	<NumberFormat
																		value={this.calculatePayable()}
																		displayType={"text"}
																		suffix={" تومان"}
																		thousandSeparator={true}
																		renderText={(value, price) => <span className="dataItemCount">{value}</span>}
																	/>
																</span>

																<span className={"old-total"}>
																	<NumberFormat
																		value={this.state.order.TotalPriceBeforeDiscount + this.state.order.AdditionalFee}
																		displayType={"text"}
																		suffix={" تومان"}
																		thousandSeparator={true}
																		renderText={(value, price) => <span className="dataItemCount">{value}</span>}
																	/>
																</span>
															</td>
														)}
													</tr>

													{this.state.order.NotePublic != null && this.state.order.NotePublic.trim() != "" ? (
														<tr>
															<td colSpan="5">
																<label>توضیح عمومی برای درج در فاکتور:</label>
																<br />
																<br />
																<ul className={"comment-text notemarker"} style={{ textAlign: "right" }}>
																	{this.state.order.NotePublic.split("\n").map((content, key) => {
																		if (content.trim() == "") {
																			return;
																		}
																		return (
																			<li className={"notecontent"} key={key}>
																				{content.indexOf("|") === -1 ? (
																					content
																				) : (
																					<ul style={{ fontSize: "12px", listStyle: "none", background: "rgba(255,255,255,0.8)", padding: "10px" }}>
																						{content.split("|").map((contentItem, key2) => {
																							if (contentItem.trim() == "") {
																								return;
																							}
																							return <li key={key2}>{contentItem}</li>;
																						})}
																					</ul>
																				)}
																			</li>
																		);
																	})}
																</ul>
															</td>
														</tr>
													) : (
														<tr />
													)}
												</tfoot>
											</table>
										</CardBody>
										<div className={"cutline"}></div>
										{this.state.savingCustomer ? (
											<CardBody>
												<CardTitle>
													<div className={"iconsminds-business-man-woman headingicon"} />
													اطلاعات مشتری
												</CardTitle>
												<div className="loading loading-inline" style={{ display: "inline-block" }}></div>
											</CardBody>
										) : (
											<CardBody>
												<CardTitle>
													<div className={"iconsminds-business-man-woman headingicon"} />
													اطلاعات مشتری
												</CardTitle>

												{this.state.order.Customer.BasicInfoLock !== true ? (
													<Row>
														<Colxx xxs="12" md="12">
															<Alert color="success" className="">
																دوست عزیز سلام،
																<br />
																به خانواده عکسچاپ خوش آمدید. لطفا اطلاعات فرم زیر را به دقت تکمیل فرمایید. (این مشخصات جهت هماهنگی تولید و ارسال سفارش و همچنین اطلاع رسانی جشنواره ها و تخفیف های عکسچاپ می باشد)
															</Alert>
														</Colxx>
														<Colxx xxs="12" md="12">
															<Label for="reciverName">
																<span>سفارش دهنده:</span>
															</Label>
														</Colxx>
														<Colxx xxs="6" style={{ paddingLeft: "5px", paddingRight: "5px" }} md="2">
															<div
																onClick={() => {
																	var tmpObj = { ...this.state.order };
																	tmpObj.Customer.Gender = "FEMALE";
																	this.setState({ order: tmpObj });
																}}
																className={classNames({ "gender-toggle": true, "gender-selectted": this.state.order.Customer.Gender == "FEMALE", "gender-error": !this.customerValidate("GENDER") })}
																style={{ display: "inline-block", float: "left" }}
															>
																<i className={"iconsminds-business-woman"}></i>&nbsp; خانم
															</div>
														</Colxx>
														<Colxx xxs="6" style={{ paddingLeft: "5px", paddingRight: "0px" }} md="2">
															<div
																onClick={() => {
																	var tmpObj = { ...this.state.order };
																	tmpObj.Customer.Gender = "MALE";
																	this.setState({ order: tmpObj });
																}}
																className={classNames({ "gender-toggle": true, "gender-selectted": this.state.order.Customer.Gender == "MALE", "gender-error": !this.customerValidate("GENDER") })}
																style={{ display: "inline-block", float: "left" }}
															>
																<i className={"iconsminds-business-man"}></i>&nbsp; آقای
															</div>
														</Colxx>
														<Colxx xxs="12" style={{ paddingLeft: "5px", paddingRight: "5px" }} md="4">
															<Input
																autoComplete="off"
																type="text"
																name="reciverName"
																id="reciverName"
																placeholder="نام"
																style={{ borderColor: this.customerValidate("NAME") ? "#4fcdc4" : "#fa9800" }}
																value={this.state.order.Customer.Name}
																onChange={(e) => {
																	var tmpObj = { ...this.state.order };
																	tmpObj.Customer.Name = e.target.value;
																	this.setState({ order: tmpObj });
																}}
															/>
														</Colxx>
														<Colxx xxs="12" style={{ paddingLeft: "5px", paddingRight: "5px" }} md="4">
															<Input
																autoComplete="off"
																type="text"
																name="reciverSurName"
																id="reciverSurName"
																style={{ borderColor: this.customerValidate("SURNAME") ? "#4fcdc4" : "#fa9800" }}
																placeholder="نام خانوادگی"
																value={this.state.order.Customer.SurName}
																onChange={(e) => {
																	var tmpObj = { ...this.state.order };
																	tmpObj.Customer.SurName = e.target.value;
																	this.setState({ order: tmpObj });
																}}
															/>
														</Colxx>

														<Colxx xxs="12" md="12">
															<Label>
																<span>
																	تاریخ تولد:
																	<span style={{ fontSize: "12px" }}> (جهت دریافت هدیه سالانه)</span>
																</span>
															</Label>
														</Colxx>
														<Colxx xxs="4" md="4">
															<Select
																components={{ Input: CustomSelectInput }}
																className={"react-select"}
																classNamePrefix="react-select"
																id="birthdayday"
																className={classNames({
																	"react-select": true,
																	"filed-border-error": !this.customerValidate("BIRTHDAY-DAY"),
																	"filed-border-success": this.customerValidate("BIRTHDAY-DAY"),
																})}
																value={this.state.order.Customer.BirthDay.Day}
																onChange={(value) => {
																	var tmpObj = { ...this.state.order };
																	tmpObj.Customer.BirthDay.Day = value;
																	this.setState({ order: tmpObj });
																}}
																options={birthDays(this.state.order.Customer.BirthDay.Month.value)}
															/>
														</Colxx>
														<Colxx xxs="4" md="4">
															<Select
																components={{ Input: CustomSelectInput }}
																className={"react-select"}
																classNamePrefix="react-select"
																id="birthdaymonth"
																className={classNames({
																	"react-select": true,
																	"filed-border-error": !this.customerValidate("BIRTHDAY-MONTH"),
																	"filed-border-success": this.customerValidate("BIRTHDAY-MONTH"),
																})}
																style={{ borderColor: this.customerValidate("BIRTHDAY-MONTH") ? "#4fcdc4" : "#fa9800" }}
																value={this.state.order.Customer.BirthDay.Month}
																onChange={(value) => {
																	this.handleBirthMonthChange(value);
																}}
																options={this.state.birthDaySelectData.months}
															/>
														</Colxx>
														<Colxx xxs="4" md="4">
															<Select
																components={{ Input: CustomSelectInput }}
																className={"react-select"}
																classNamePrefix="react-select"
																id="birthdayyear"
																className={classNames({
																	"react-select": true,
																	"filed-border-error": !this.customerValidate("BIRTHDAY-YEAR"),
																	"filed-border-success": this.customerValidate("BIRTHDAY-YEAR"),
																})}
																value={this.state.order.Customer.BirthDay.Year}
																onChange={(value) => {
																	var tmpObj = { ...this.state.order };
																	tmpObj.Customer.BirthDay.Year = value;
																	this.setState({ order: tmpObj });
																}}
																options={this.state.birthDaySelectData.years}
															/>
														</Colxx>
														<Colxx xxs="12" md="12">
															<Label>
																<span>نحوه آشنایی با عکسچاپ:</span>
															</Label>
														</Colxx>

														<Colxx xxs="12" md="12" className={classNames({ familirty: true, "familirity-error": !this.customerValidate("FAMILIARITY") })}>
															{this.state.FamiliarityMethods.map((item, index) => {
																return (
																	<CustomInput
																		key={index}
																		type="radio"
																		id={"familiarity" + index}
																		name="FamiliarityMethod"
																		label={item}
																		checked={this.state.order.Customer.FamiliarityMethod == item}
																		onChange={() => {
																			var tmpObj = { ...this.state.order };
																			tmpObj.Customer.FamiliarityMethod = item;
																			this.setState({ order: tmpObj });
																		}}
																	/>
																);
															})}
														</Colxx>

														<Colxx xxs="12" md="12">
															<br />
															<Button
																onClick={() => {
																	this.customerSet();
																}}
																color="light"
																disabled={!this.customerValidate("ALL")}
																className={"default mb-2"}
																style={{ width: "100%", color: "white", background: this.customerValidate("ALL") ? "#4fcdc4" : "#fa9800", display: "inline-block", fontSize: "18px" }}
															>
																ثبت اطلاعات و ادامه
																<i className={"iconsminds-arrow-back-3"} style={{ fontSize: "20px" }}></i>
															</Button>
														</Colxx>
													</Row>
												) : (
													<Row>
														<Colxx xxs="12" md="12">
															<Label for="reciverName">
																<i
																	style={{ fontSize: "20px" }}
																	className={classNames({
																		"iconsminds-business-man": this.state.order.Customer.Gender == "MALE" ? true : false,
																		"iconsminds-business-woman": this.state.order.Customer.Gender == "FEMALE" ? true : false,
																	})}
																></i>
																{this.state.order.Customer.Name} {this.state.order.Customer.SurName} - {this.state.order.Customer.Mobile}
															</Label>
														</Colxx>
													</Row>
												)}
											</CardBody>
										)}
										<div className={classNames({ cutline: this.state.order.Customer.BasicInfoLock })}></div>
										{this.state.order.Customer.BasicInfoLock == true ? (
											<Fragment>
												<CardBody>
													<CardTitle>
														<div className={"iconsminds-shop-2 headingicon"} />
														نحوه دریافت
													</CardTitle>
													<label>سفارش را حضوری تحویل میگیرم:</label>
													<Switch
														className="custom-switch custom-switch-primary"
														checked={this.state.DeliveryInPerson}
														onChange={(DeliveryInPerson) => {
															this.setState({ DeliveryInPerson });
														}}
														style={{
															display: "inline-block",
															marginLeft: "12px",
															float: "left",
														}}
													/>
													<br />
													<label>سفارش برایم ارسال شود:</label>
													<Switch
														className="custom-switch custom-switch-primary"
														checked={!this.state.DeliveryInPerson}
														onChange={(DeliveryInPerson) => {
															this.setState({ DeliveryInPerson: !DeliveryInPerson });
														}}
														style={{
															display: "inline-block",
															marginLeft: "12px",
															float: "left",
														}}
													/>
													&nbsp;&nbsp;
												</CardBody>
												<div className={"cutline"}></div>
												<CardBody>
													<CardTitle>
														<div className={"simple-icon-location-pin headingicon"} />
														{classNames({
															"اطلاعات سفارش دهنده": this.state.DeliveryInPerson,
															"اطلاعات ارسال سفارش": !this.state.DeliveryInPerson,
														})}
													</CardTitle>
													{this.state.deletingAddress == true ? (
														<div className="loading"></div>
													) : (
														<table style={{ width: "100%" }}>
															{this.state.addresses.map((Address, index) => {
																return (
																	<tbody
																		key={index}
																		className={classNames({ "address-item": true, "address-item-selected": this.state.order.SelectedAddressId == Address.AddressId })}
																		onClick={() => {
																			var tmpObj = { ...this.state.order };
																			tmpObj.SelectedAddressId = Address.AddressId;
																			this.setState({ order: tmpObj });
																		}}
																	>
																		<tr className={"selected-address-header"} style={{ width: "100%" }}>
																			<td colSpan={4}>
																				<i className={"simple-icon-check"} style={{ fontSize: "20px" }}></i>&nbsp; آدرس انتخاب شده
																			</td>
																		</tr>
																		<tr style={{ width: "100%", display: "inline-flex" }}>
																			<td style={{ width: "100px", fontWeight: "bold", padding: "5px" }}>
																				{classNames({
																					"سفارش دهنده": this.state.DeliveryInPerson,
																					"تحویل گیرنده": !this.state.DeliveryInPerson,
																				})}
																				:
																			</td>
																			<td style={{ width: "calc(100% - 100px)", padding: "5px" }} colSpan={3}>
																				<i
																					className={classNames({
																						"iconsminds-business-man": Address.Gender == "MALE" ? true : false,
																						"iconsminds-business-woman": Address.Gender == "FEMALE" ? true : false,
																					})}
																				></i>
																				{Address.Name} {Address.SurName}
																			</td>
																		</tr>

																		<tr style={{ width: "100%", display: "inline-flex" }}>
																			<td style={{ width: "100px", fontWeight: "bold", padding: "5px" }}>
																				<strong>آدرس:&nbsp;</strong>
																			</td>
																			<td colSpan={3} style={{ width: "100%", padding: "5px" }}>
																				{Address.State} - &nbsp;
																				{Address.City} - &nbsp;
																				{Address.State == "تهران" && Address.City == "تهران" ? <span>{Address.Zone} - &nbsp;</span> : <span />}
																				{Address.Address} &nbsp;
																				<br />
																				<i style={{ fontSize: "14px", fontStyle: "unset", fontWeight: "bold", display: Address.PostCode != null && Address.PostCode.length > 5 ? "inline-block" : "none" }}>کد پستی:</i>
																				&nbsp;
																				{Address.PostCode}
																			</td>
																		</tr>
																		<tr style={{ width: "100%", display: "inline-flex" }}>
																			<td colSpan={4} style={{ width: "100%", padding: "5px" }}>
																				<i className={"simple-icon-screen-smartphone"} style={{ fontSize: "20px" }}></i>&nbsp;
																				{Address.Mobile}
																				&nbsp;&nbsp;
																				<i className={"iconsminds-old-telephone"} style={{ fontSize: "18px", display: Address.Tel != null && Address.Tel.length > 5 ? "inline-block" : "none" }}></i>&nbsp;
																				{Address.Tel}
																				&nbsp;&nbsp;
																			</td>
																		</tr>

																		<tr style={{ width: "100%", display: "inline-flex" }}>
																			<td colSpan={4} style={{ width: "100%" }}>
																				<Button
																					outline
																					color="primary"
																					className="mb-2"
																					onClick={() => {
																						this.addressDelete(Address.AddressId);
																					}}
																					style={{ padding: "5px", float: "left", fontSize: "20px", marginTop: "10px", display: this.state.order.Position == "PAYMENT" ? "block" : "none", paddingBottom: "1px" }}
																				>
																					<div className={"glyph-icon simple-icon-trash"} style={{ float: "left", display: "inline-block" }} />
																					<span style={{ fontSize: "12px", float: "left", display: "inline-block", lineHeight: "25px" }}>حذف آدرس</span>
																				</Button>
																			</td>
																		</tr>
																	</tbody>
																);
															})}
														</table>
													)}

													{this.state.order.Position == "PAYMENT" ? (
														<Fragment>
															<div className="border productPanel">
																<Button block color="link" className="text-right" onClick={() => this.toggleNewAddress()} aria-expanded={this.state.toggleNewAddress}>
																	<i className="glyph-icon iconsminds-location-2" style={{ marginLeft: "5px", fontSize: "14px" }}></i>
																	ثبت آدرس جدید
																	<i className="glyph-icon simple-icon-arrow-down" style={{ marginRight: "10px", fontSize: "10px" }}></i>
																</Button>
																<Collapse isOpen={this.state.toggleNewAddress}>
																	<div className="p-4">
																		<Row className="mb-4">
																			<Colxx xxs="12" md="6" style={{ paddingLeft: "5px", paddingRight: "5px" }}>
																				<Select
																					components={{ Input: CustomSelectInput }}
																					className={classNames({
																						"react-select": true,
																						"filed-border-error": !this.addressValidate("STATE"),
																						"filed-border-success": this.addressValidate("STATE"),
																					})}
																					classNamePrefix="react-select"
																					id="newAddressState"
																					value={this.state.newAddress.State}
																					onChange={this.handleChangeState}
																					options={this.state.savingNewAddress ? [] : IranStates}
																				/>
																			</Colxx>
																			<Colxx xxs="12" md="6" style={{ paddingLeft: "5px", paddingRight: "5px" }}>
																				<Select
																					components={{ Input: CustomSelectInput }}
																					className={classNames({
																						"react-select": true,
																						"filed-border-error": !this.addressValidate("CITY"),
																						"filed-border-success": this.addressValidate("CITY"),
																					})}
																					classNamePrefix="react-select"
																					id="newAddressCity"
																					value={this.state.newAddress.City}
																					onChange={this.handleChangeCity}
																					options={
																						this.state.savingNewAddress
																							? []
																							: IranCities.filter((row) => {
																									return row.state == this.state.newAddress.State.value;
																							  })
																					}
																				/>
																			</Colxx>
																			<Colxx xxs="12" style={{ paddingLeft: "5px", paddingRight: "5px" }} md="6">
																				<Input
																					autoComplete="off"
																					type="text"
																					name="reciverPostCode"
																					disabled={this.state.savingNewAddress}
																					id="reciverPostCode"
																					placeholder="کد پستی (اختیاری)"
																					value={this.state.newAddress.PostCode}
																					onChange={(e) => {
																						var tmpObj = { ...this.state.newAddress };
																						tmpObj.PostCode = e.target.value;
																						this.setState({ newAddress: tmpObj });
																					}}
																				/>
																			</Colxx>
																			{this.state.newAddress.State.value == 8 && this.state.newAddress.City.value == 301 ? (
																				<Colxx xxs="12" md="6" style={{ paddingLeft: "5px", paddingRight: "5px" }}>
																					<Select
																						components={{ Input: CustomSelectInput }}
																						className={classNames({
																							"react-select": true,
																							"filed-border-error": !this.addressValidate("ZONE"),
																							"filed-border-success": this.addressValidate("ZONE"),
																						})}
																						classNamePrefix="react-select"
																						id="newAddressCity"
																						disabled={this.state.savingNewAddress}
																						value={this.state.newAddress.Zone}
																						onChange={this.handleChangeZone}
																						options={this.state.savingNewAddress ? [] : TehranZones}
																					/>
																				</Colxx>
																			) : (
																				false
																			)}

																			<Colxx xxs="12" md="12" style={{ paddingLeft: "5px", paddingRight: "5px" }}>
																				<textarea
																					className={"validateable-input"}
																					style={{ width: "100%", border: "1px solid #d7d7d7", padding: "10px", borderColor: this.addressValidate("ADDRESS") ? "#4fcdc4" : "#fa9800" }}
																					placeholder="آدرس کامل با طبقه و پلاک و ..."
																					disabled={this.state.savingNewAddress}
																					value={this.state.newAddress.Address}
																					onChange={(e) => {
																						var tmpObj = { ...this.state.newAddress };
																						tmpObj.Address = e.target.value;
																						this.setState({ newAddress: tmpObj });
																					}}
																					rows="4"
																				/>
																			</Colxx>
																		</Row>
																		<Row>
																			<Colxx xxs="12" md="12">
																				<Label for="reciverName">
																					<span>
																						{classNames({
																							"سفارش دهنده": this.state.DeliveryInPerson,
																							"تحویل گیرنده": !this.state.DeliveryInPerson,
																						})}
																					</span>
																				</Label>
																			</Colxx>
																			<Colxx xxs="6" style={{ paddingLeft: "5px", paddingRight: "5px" }} md="2">
																				<div
																					onClick={() => {
																						var tmpObj = { ...this.state.newAddress };
																						tmpObj.Gender = "FEMALE";
																						this.setState({ newAddress: tmpObj });
																					}}
																					className={classNames({ "gender-toggle": true, "gender-selectted": this.state.newAddress.Gender == "FEMALE", "gender-error": !this.addressValidate("GENDER") })}
																					style={{ display: "inline-block", float: "left" }}
																				>
																					<i className={"iconsminds-business-woman"}></i>&nbsp; خانم
																				</div>
																			</Colxx>
																			<Colxx xxs="6" style={{ paddingLeft: "5px", paddingRight: "0px" }} md="2">
																				<div
																					onClick={() => {
																						var tmpObj = { ...this.state.newAddress };
																						tmpObj.Gender = "MALE";
																						this.setState({ newAddress: tmpObj });
																					}}
																					className={classNames({ "gender-toggle": true, "gender-selectted": this.state.newAddress.Gender == "MALE", "gender-error": !this.addressValidate("GENDER") })}
																					style={{ display: "inline-block", float: "left" }}
																				>
																					<i className={"iconsminds-business-man"}></i>&nbsp; آقای
																				</div>
																			</Colxx>
																			<Colxx xxs="12" style={{ paddingLeft: "5px", paddingRight: "5px" }} md="4">
																				<Input
																					autoComplete="off"
																					type="text"
																					name="reciverName"
																					disabled={this.state.savingNewAddress}
																					className={"validateable-input"}
																					id="reciverName"
																					style={{ borderColor: this.addressValidate("NAME") ? "#4fcdc4" : "#fa9800" }}
																					placeholder="نام"
																					value={this.state.newAddress.Name}
																					onChange={(e) => {
																						var tmpObj = { ...this.state.newAddress };
																						tmpObj.Name = e.target.value;
																						this.setState({ newAddress: tmpObj });
																					}}
																				/>
																			</Colxx>
																			<Colxx xxs="12" style={{ paddingLeft: "5px", paddingRight: "5px" }} md="4">
																				<Input
																					autoComplete="off"
																					type="text"
																					name="reciverSurName"
																					disabled={this.state.savingNewAddress}
																					className={"validateable-input"}
																					id="reciverSurName"
																					style={{ borderColor: this.addressValidate("SURNAME") ? "#4fcdc4" : "#fa9800" }}
																					placeholder="نام خانوادگی"
																					value={this.state.newAddress.SurName}
																					onChange={(e) => {
																						var tmpObj = { ...this.state.newAddress };
																						tmpObj.SurName = e.target.value;
																						this.setState({ newAddress: tmpObj });
																					}}
																				/>
																			</Colxx>
																			<Colxx xxs="12" style={{ paddingLeft: "5px", paddingRight: "5px" }} md="6">
																				<Input
																					autoComplete="off"
																					type="text"
																					disabled={this.state.savingNewAddress}
																					name="reciverMobile"
																					id="reciverMobile"
																					className={"validateable-input"}
																					style={{ borderColor: this.addressValidate("MOBILE") ? "#4fcdc4" : "#fa9800" }}
																					placeholder="موبایل: 09123456789"
																					value={this.state.newAddress.Mobile}
																					onChange={(e) => {
																						var tmpObj = { ...this.state.newAddress };
																						tmpObj.Mobile = this.cleanMobile(e.target.value);
																						this.setState({ newAddress: tmpObj });
																					}}
																				/>
																			</Colxx>
																			<Colxx xxs="12" style={{ paddingLeft: "5px", paddingRight: "5px" }} md="6">
																				<Input
																					autoComplete="off"
																					type="text"
																					name="reciverTel"
																					disabled={this.state.savingNewAddress}
																					id="reciverTel"
																					placeholder="تلفن ثابت (اختیاری)"
																					value={this.state.newAddress.Tel}
																					onChange={(e) => {
																						var tmpObj = { ...this.state.newAddress };
																						tmpObj.Tel = e.target.value;
																						this.setState({ newAddress: tmpObj });
																					}}
																				/>
																			</Colxx>

																			<Colxx xxs="12" style={{ paddingLeft: "5px", paddingRight: "5px" }} md="12">
																				<div className="loading loading-inline" style={{ display: this.state.savingNewAddress ? "inline-block" : "none" }}></div>
																				<Button
																					color="primary"
																					disabled={this.state.savingNewAddress || !this.addressValidate("ALL")}
																					className="default mb-2"
																					style={{ display: this.state.savingNewAddress ? "none" : "inline-block", float: "left" }}
																					onClick={() => {
																						this.addressAdd();
																					}}
																				>
																					<i className="simple-icon-plus"></i>&nbsp; ثبت آدرس
																				</Button>
																			</Colxx>
																		</Row>
																	</div>
																</Collapse>
															</div>
															<br />
														</Fragment>
													) : (
														<div />
													)}
												</CardBody>
											</Fragment>
										) : (
											<div />
										)}

										{this.state.addresses.length > 0 && this.state.addresses.filter((address) => address.AddressId == this.state.order.SelectedAddressId)[0].City == "تهران" ? (
											<Fragment>
												<div className={"cutline"}></div>
												<CardBody>
													<CardTitle>محدوده ارسال رایگان در شهر تهران</CardTitle>
													<Row>
														<Colxx xxs="12" md="12">
															<table>
																<tr style={{ width: "100%", display: "inline-flex" }}>
																	<td colSpan={4} style={{ padding: "10px" }}>
																		<div style={{ width: "calc(100%)" }}>
																			<Alert color="success" className="" style={{ textAlign: "center" }}>
																				<img src="/assets/img/freedelivery.png" style={{ width: "200px", display: "block", marginLeft: "auto", marginRight: "auto", marginBottom: "10px" }} />
																				اگر آدرس دقیقا داخل محوده مشخص شده باشد شامل ارسال رایگان با پیک عکسچاپ می شود. زمان ارسال حد اکثر یک روز کاری می باشد.
																			</Alert>
																			<Alert color="warning" className="" style={{ textAlign: "center" }}>
																				اگر آدرس خارج از محدوده است جهت ارسال با روش دلخواه با اپراتور هماهنگ فرمایید.
																			</Alert>
																		</div>
																		<div style={{ width: "calc(100%)" }}>
																			<Button
																				color="primary"
																				className="mb-2 default"
																				onClick={() => {
																					// this.ModalMapToggle();
																					window.open("https://akschap.com/ersal", "_blank");
																				}}
																				style={{ padding: "10px", paddingBottom: "1px", fontSize: "18px", marginLeft: "auto", marginRight: "auto", display: "block" }}
																			>
																				<div className={"glyph-icon iconsminds-map2"} style={{ fontSize: "40px", height: "50px" }} />
																				مشاهده محدوده ارسال رایگان
																			</Button>

																			<Modal isOpen={this.state.ModalMap} toggle={this.ModalMapToggle}>
																				<ModalHeader toggle={this.ModalMapToggle}>محدوده ارسال رایگان پیک عکسچاپ در شهر تهران</ModalHeader>
																				<ModalBody>
																					<iframe src="https://akschap.com/%D8%B9%DA%A9%D8%B3%DA%86%D8%A7%D9%BE/%D8%B4%D8%B1%D8%A7%DB%8C%D8%B7-%D8%A7%D8%B1%D8%B3%D8%A7%D9%84/" width="100%" height="480"></iframe>
																				</ModalBody>
																				<ModalFooter></ModalFooter>
																			</Modal>
																		</div>
																	</td>
																</tr>
															</table>
														</Colxx>
													</Row>
												</CardBody>
											</Fragment>
										) : (
											<span />
										)}

										{this.state.order.SelectedAddressId == -1 ? (
											<Alert color="danger" className="">
												برای ثبت سفارش لازم است یک آدرس انتخاب نمایید. پس از ثبت آدرس روی آن کلیک کنید تا آبی و انتخاب شده باشد.
											</Alert>
										) : (
											<div />
										)}
										{this.state.addresses.length > 1 && !this.state.DeliveryInPerson ? (
											<div>
												<div className={classNames({ cutline: this.state.order.Customer.BasicInfoLock })}></div>
												<Fragment>
													<Fragment>
														<CardBody>
															<CardTitle>
																<br />
																آدرس
																{classNames({
																	" سفارش دهنده": this.state.DeliveryInPerson,
																	" ارسال سفارش": !this.state.DeliveryInPerson,
																})}
															</CardTitle>
															{this.state.order.Customer.BasicInfoLock == true && this.state.order.SelectedAddressId != -1 ? (
																<Alert color="danger" className="" style={{ textAlign: "center" }}>
																	{(finalAddress = this.state.addresses.find((obj) => obj.AddressId == this.state.order.SelectedAddressId)) && (
																		<span>
																			{finalAddress.State} - {finalAddress.City} - {finalAddress.Address}
																		</span>
																	)}
																</Alert>
															) : (
																<Alert color="danger" className="" style={{ textAlign: "center" }}>
																	از بالا یک آدرس تحویل انتخاب نمایید.
																</Alert>
															)}
														</CardBody>
													</Fragment>
												</Fragment>
											</div>
										) : (
											<span />
										)}
										<div className={classNames({ cutline: this.state.order.Customer.BasicInfoLock })}></div>

										{this.state.order.Customer.BasicInfoLock == true && this.state.order.SelectedAddressId != -1 ? (
											<Fragment>
												<CardBody>
													<CardTitle>توضیحات سفارش</CardTitle>
													<Row>
														<Colxx xxs="12" md="12">
															<Label for="reciverName">
																<span>توضیحات سفارش:</span>
															</Label>
														</Colxx>
														<Colxx xxs="12" md="12" style={{ paddingLeft: "5px", paddingRight: "5px" }}>
															<textarea
																style={{ width: "100%", border: "1px solid #d7d7d7", padding: "10px" }}
																placeholder="مثلا:  (حتما تحویل خانم ایرانی شود) "
																value={this.state.order.NoteCustomer}
																disabled={this.state.order.Position != "PAYMENT"}
																onChange={(e) => {
																	var tmpObj = { ...this.state.order };
																	tmpObj.NoteCustomer = e.target.value;
																	this.setState({ order: tmpObj });
																}}
																rows="4"
															/>
														</Colxx>
													</Row>
												</CardBody>
												<div className={"cutline"}></div>
											</Fragment>
										) : (
											<div />
										)}
										{this.state.order.Customer.BasicInfoLock == true && this.state.order.SelectedAddressId != -1 ? (
											<CardBody>
												<CardTitle>
													<div className={"iconsminds-credit-card headingicon"} />
													{classNames({ نحوه: this.state.order.Position == "PAYMENT", اطلاعات: this.state.order.Position == "PROCESS" })} پرداخت
												</CardTitle>

												{this.state.order.Position == "PAYMENT" ? (
													<Row>
														<Colxx xxs="6" md="6">
															<div
																onClick={() => {
																	this.setState({ paymentType: "online" });
																}}
																style={{ cursor: "pointer" }}
																className={classNames({ "payment-type": true, "payment-type-selected": this.state.paymentType == "online" })}
															>
																<strong>
																	<i
																		className={classNames({
																			"simple-icon-check": this.state.paymentType == "online",
																		})}
																	></i>
																	&nbsp; پرداخت آنلاین
																</strong>
															</div>
														</Colxx>
														<Colxx xxs="6" md="6">
															<div
																style={{ cursor: "pointer" }}
																className={classNames({ "payment-type": true, "payment-type-selected": this.state.paymentType == "other" })}
																onClick={() => {
																	this.setState({ paymentType: "other" });
																}}
															>
																<strong>
																	<i
																		className={classNames({
																			"simple-icon-check": this.state.paymentType == "other",
																		})}
																	></i>
																	&nbsp; کارت به کارت
																</strong>
															</div>
														</Colxx>
														<Colxx xxs="12" md="12">
															<br />
															{this.state.paymentType == "other" ? (
																<div className="shetabcard">
																	<img className="shetablogo" src="/assets/img/shetablogo.png" />
																	<img className="banklogo" src={"/assets/img/"+this.state.order.Card.bank_name_slug+".png"} />
																	<span className="shetabnumber">{this.state.order.Card.card_number_formatted}</span>
																	<span className="shebanumber">{this.state.order.Card.sheba_formatted}</span>
																	<span className="shetabname">{this.state.order.Card.name} {this.state.order.Card.surname} - {this.state.order.Card.bank_name}</span>
																</div>
															) : (
																<Alert color="success" className="" style={{ textAlign: "center" }}>
																	جهت اطمینان خاطر شما سایت عکسچاپ دارای نماد اعتماد الکترونیک ۳ ستاره است.
																	<br />
																	<br />
																	برای استعلام روی نماد الکترونیک کلیک نمایید:
																	<br />
																	<br />
																	<a target="_blank" href="https://akschap.com/namad.php" style={{ textAlign: "center", display: "block" }}>
																		{/* <img referrerPolicy="origin" src="https://Trustseal.eNamad.ir/logo.aspx?id=57664&amp;Code=c8ImVjT7jseKMWTeNIHF" alt="" style={{ cursor: "pointer" }} id="rgvllbrhbrgwbrgwhwla" /> */}
																		<img
																			referrerPolicy="origin"
																			src="/assets/img/namadtest.png"
																			alt=""
																			style={{ cursor: "pointer" }}
																			id="rgvllbrhbrgwbrgwhwla"
																			style={{ backgroundColor: "#ffffff4f", padding: "10px", borderRadius: "2px", cursor: "pointer" }}
																		/>
																	</a>
																</Alert>
															)}
														</Colxx>
														{this.state.order.NotePayment != null && this.state.order.NotePayment.trim() !== "" ? (
															<Colxx xxs="12" md="12">
																<Alert color="danger" className="">
																	<ul>
																		{this.state.order.NotePayment.split("\n").map((content, key) => {
																			if (content.trim() == "") {
																				return;
																			}
																			return <li key={key}>{content}</li>;
																		})}
																	</ul>
																</Alert>
															</Colxx>
														) : (
															<div />
														)}
														<Colxx xxs="12" md="12">
															<br />
															{this.state.savingOrder ? (
																<div style={{ width: "100%", display: "flex", height: "40px" }}>
																	<div className="loading loading-inline" style={{ marginLeft: "auto", marginRight: "auto" }}></div>
																</div>
															) : (
																<div>
																	<table class="payment-total-summary">
																		{this.state.paymentType == "online" && (
																			<tr>
																				<th>جمع سفارش</th>
																				<td>
																					<NumberFormat
																						value={this.calculatePayable()}
																						displayType={"text"}
																						suffix={" تومان"}
																						thousandSeparator={true}
																						renderText={(value, price) => <span className="dataItemCount">{value}</span>}
																					/>
																				</td>
																			</tr>
																		)}
																		{this.state.paymentType == "online" && (
																			<tr>
																				<th>مالیات برارزش افزوده</th>
																				<td>
																					<NumberFormat
																						value={(this.calculatePayable() * 10) / 100}
																						displayType={"text"}
																						suffix={" تومان"}
																						thousandSeparator={true}
																						renderText={(value, price) => <span className="dataItemCount">{value}</span>}
																					/>
																				</td>
																			</tr>
																		)}
																		<tr>
																			<th>قابل پرداخت</th>
																			<td style={{ color: "black" }}>
																				<NumberFormat
																					value={this.calculatePayable() + (this.state.paymentType == "online" ? (this.calculatePayable() * 10) / 100 : 0)}
																					displayType={"text"}
																					suffix={" تومان"}
																					thousandSeparator={true}
																					renderText={(value, price) => <span className="dataItemCount">{value}</span>}
																				/>
																			</td>
																		</tr>
																	</table>
																	<Button
																		onClick={() => {
																			this.orderSet();
																		}}
																		color="light"
																		className={"default mb-2"}
																		disabled={!this.orderValidate("ALL")}
																		style={{ width: "100%", color: "white", background: this.state.order.SelectedAddressId == -1 ? "#fa9800" : "#4fcdc4", display: "inline-block", fontSize: "18px" }}
																	>
																		{classNames({
																			"پرداخت آنلاین": this.state.paymentType == "online",
																			"ثبت سفارش": this.state.paymentType == "other",
																		})}
																		&nbsp;
																		<i className={classNames({ "simple-icon-credit-card": this.state.paymentType == "online", "simple-icon-clock": this.state.paymentType != "online" })} style={{ fontSize: "20px" }}></i>
																	</Button>
																</div>
															)}
															{this.orderValidate("ALL") &&
															this.state.lastPrepareDataSelectedAddressId !== -1 &&
															(this.state.order.CustPaymentSelection == "other" || this.state.order.CustPaymentSelection == "online") &&
															this.state.paymentType == "other" ? (
																<Alert color="danger" className="">
																	<ul>
																		<li>در انتظار تکمیل پرداخت.</li>
																		<li>لطفا پس از وایز وجه رسید پرداخت را برای اپراتور ارسال نمایید تا سفارش شما در صف تولید قرار گیرد.</li>
																		<li>در نظر داشته باشید اولیت در پردازش و تخصیص موجودی کالا ها بر اساس زمان ثبت پرداخت سفارش است.</li>
																	</ul>
																</Alert>
															) : (
																<div />
															)}
															‌
														</Colxx>
													</Row>
												) : (
													<Row>
														<Colxx xxs="12" md="12">
															<Alert color="success" className="">
																<ul>
																	<li>
																		{classNames({
																			"کارت به کارت": this.state.order.PaymentType == "CARD" ? true : false,
																			"درگاه سایت": this.state.order.PaymentType == "SITE" ? true : false,
																			"پرداخت نقدی": this.state.order.PaymentType == "CASH" ? true : false,
																			"پرداخت پوز": this.state.order.PaymentType == "POS" ? true : false,
																			"بدون پرداخت": this.state.order.PaymentType == "NONE" ? true : false,
																		})}
																	</li>
																	{this.state.order.NotePayment.split("\n").map((content, key) => {
																		if (content.trim() == "") {
																			return;
																		}
																		return <li key={key}>{content}</li>;
																	})}
																</ul>
															</Alert>
														</Colxx>
													</Row>
												)}
											</CardBody>
										) : (
											<div />
										)}
									</Card>
								</Colxx>
								<Colxx sm={3} className={"mobile-hide"}></Colxx>
							</FormGroup>
						</Form>
					</Colxx>
				</Row>
			</Fragment>
		);
	}
}

class FactorTableRow extends Component {
	render() {
		const {
			data: { OrderProductId, Name, Type, Price, Count },
			index,
		} = this.props;
		var color = index % 2 == 0 ? "#00ffed0d" : "#ffffff";
		var color = "#ffffff";
		return (
			<tr style={{ backgroundColor: color }}>
				<td style={{ textAlign: "center", width: "20px" }}>{index + 1}</td>
				<td style={{ fontWeight: "bold", color: "black" }}>{Name}</td>
				<td style={{ textAlign: "center", width: "80px" }}>
					<NumberFormat style={{ textAlign: "center" }} value={Price} className="text-muted" displayType={"text"} thousandSeparator={true} renderText={(value, prop) => <div>{value}</div>} />
				</td>
				<td style={{ textAlign: "center", width: "20px" }}>
					<NumberFormat style={{ textAlign: "center" }} value={Count} className="text-muted" displayType={"text"} thousandSeparator={true} renderText={(value, prop) => <div>{value}</div>} />
				</td>
				<td style={{ textAlign: "center", width: "250px" }}>
					<NumberFormat style={{ textAlign: "center" }} value={Price * Count} className="text-muted" displayType={"text"} suffix={" تومان"} thousandSeparator={true} renderText={(value, prop) => <div>{value}</div>} />
				</td>
			</tr>
		);
	}
}

class FactorMobileTableRow extends Component {
	render() {
		const {
			data: { OrderProductId, Name, Type, Price, Count },
			index,
		} = this.props;
		var color = index % 2 == 0 ? "#00ffed0d" : "#ffffff";
		var color = "#ffffff";
		return (
			<tbody style={{ backgroundColor: color }}>
				<tr>
					<td colSpan={6} style={{ textAlign: "right", fontWeight: "bold", color: "black" }}>
						{index + 1} - {Name}
					</td>
				</tr>
				<tr>
					<td colSpan={2} style={{ textAlign: "center", width: "calc(100%/3)" }}>
						<span style={{ fontSize: "12px" }}>قیمت واحد:</span>

						<NumberFormat style={{ textAlign: "center" }} value={Price} className="text-muted" displayType={"text"} thousandSeparator={true} renderText={(value, prop) => <div>{value}</div>} />
					</td>
					<td colSpan={2} style={{ textAlign: "center", width: "calc(100%/3)" }}>
						<span style={{ fontSize: "12px" }}>تعداد:</span>
						<NumberFormat style={{ textAlign: "center" }} value={Count} suffix={" عدد"} className="text-muted" displayType={"text"} thousandSeparator={true} renderText={(value, prop) => <div>{value}</div>} />
					</td>

					<td colSpan={2} style={{ textAlign: "center", width: "calc(100%/3)" }}>
						<span style={{ fontSize: "12px" }}>قیمت کل:</span>
						<NumberFormat style={{ textAlign: "center" }} value={Price * Count} className="text-muted" displayType={"text"} suffix={" تومان"} thousandSeparator={true} renderText={(value, prop) => <div>{value}</div>} />
					</td>
				</tr>
			</tbody>
		);
	}
}
export default injectIntl(TakeOrder);
